import Link from 'next/link';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center">
                <span className="text-white font-bold text-sm">中科</span>
              </div>
              <span className="text-lg font-semibold text-white">中科企服</span>
            </div>
            <p className="text-sm text-gray-400">
              专业的科技服务平台，为企业提供标准参编、科技成果评价、贸易增量等一站式服务。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">快速链接</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/standard" className="text-sm hover:text-blue-400 transition-colors">
                  标准参编
                </Link>
              </li>
              <li>
                <Link href="/evaluation" className="text-sm hover:text-blue-400 transition-colors">
                  科技成果评价
                </Link>
              </li>
              <li>
                <Link href="/trade" className="text-sm hover:text-blue-400 transition-colors">
                  贸易增量
                </Link>
              </li>
              <li>
                <Link href="/about" className="text-sm hover:text-blue-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link href="/faq" className="text-sm hover:text-blue-400 transition-colors">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">服务支持</h3>
            <ul className="space-y-2">
              <li>
                <Link href="#" className="text-sm hover:text-blue-400 transition-colors">
                  文件下载
                </Link>
              </li>
              <li>
                <Link href="#" className="text-sm hover:text-blue-400 transition-colors">
                  在线咨询
                </Link>
              </li>
              <li>
                <Link href="#" className="text-sm hover:text-blue-400 transition-colors">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">联系我们</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="tel:4000757209" className="hover:text-blue-400 transition-colors">
                  电话：187-0278-9722（李老师）
                </a>
              </li>
              <li>
                <a href="mailto:781260356@qq.com" className="hover:text-blue-400 transition-colors">
                  邮箱：781260356@qq.com
                </a>
              </li>
              <li className="max-w-[200px]">地址：武汉经济技术开发区车城东路10号创思汇科技大厦16层1601-43号室</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>© 2024 中科企服（湖北）科技有限公司. 保留所有权利.</p>
        </div>
      </div>
    </footer>
  );
}